import { DataBean } from "../DataBean";

export class CreateMovementTaxNote extends DataBean {



    public async createBankingNoteDocumentForFinancialTaxMovements(idBankingAccount: any, idAccount: any, accountantDate: any, items: any, description: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_createBankingNoteDocumentForFinancialTaxMovements_Number_Number_java.util.Date_java.util.List_String_Number", [idBankingAccount, idAccount, accountantDate, items, description, idEmployee]);
    }

}